import { render, staticRenderFns } from "./InactiveDevice.vue?vue&type=template&id=2339ef2b"
import script from "./InactiveDevice.vue?vue&type=script&lang=js"
export * from "./InactiveDevice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports